import React from 'react';
import { FiArrowRight, FiSmartphone } from 'react-icons/fi';

export default function IosFooterPromo() {
  return (
    <section className="ios-footer-promo" aria-label="OdysseyAI for iOS">
      <div className="ios-footer-promo__copy">
        <FiSmartphone aria-hidden />
        <div>
          <h2>Your next adventure, in your pocket.</h2>
          <p>OdysseyAI for iPhone and iPad · Coming soon</p>
        </div>
      </div>
      <a className="ios-footer-promo__link" href="/about#ios">
        Explore the iOS app <FiArrowRight aria-hidden />
      </a>
      <a
        href="/about#ios"
        className="ios-footer-promo__qr"
        aria-label="Scan or open iOS information"
      >
        <img
          src="/assets/odyssey-ios-qr.svg"
          alt="QR code for OdysseyAI iOS information"
          width="76"
          height="76"
          loading="lazy"
        />
        <span>Scan to learn more</span>
      </a>
    </section>
  );
}
